module.exports = require("./ja-JP.js");